export { default as Image, type ImageProps } from './Image'
